import React from "react";
import CompanyLogo from "./CompanyLogo";

const LogoShowcase: React.FC = () => {
  return (
    <div className="p-8 space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Company Logo Showcase
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Different variants and sizes of the Infinite Orders logo component
        </p>
      </div>

      {/* Size Variants */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Size Variants
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Small (sm)
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="sm" variant="default" />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Medium (md)
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="md" variant="default" />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Large (lg)
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="default" />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Extra Large (xl)
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="xl" variant="default" />
            </div>
          </div>
        </div>
      </div>

      {/* Style Variants */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Style Variants
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Default
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="default" />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Minimal
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="minimal" />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Full
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="full" />
            </div>
          </div>
        </div>
      </div>

      {/* With/Without Tagline */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Tagline Options
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              With Tagline
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="full" showTagline={true} />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Without Tagline
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="full" showTagline={false} />
            </div>
          </div>
        </div>
      </div>

      {/* Animation Options */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Animation Options
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Animated
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="default" animated={true} />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              Static
            </h3>
            <div className="flex justify-center">
              <CompanyLogo size="lg" variant="default" animated={false} />
            </div>
          </div>
        </div>
      </div>

      {/* Usage Examples */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Usage Examples
        </h2>
        <div className="space-y-4">
          <div className="p-6 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 rounded-lg border border-gray-200 dark:border-gray-600">
            <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-4">
              Authentication Pages
            </h3>
            <div className="flex justify-center">
              <CompanyLogo
                size="xl"
                variant="full"
                animated={true}
                showTagline={true}
              />
            </div>
          </div>

          <div className="p-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-4">
              Header Navigation
            </h3>
            <div className="flex justify-center">
              <CompanyLogo
                size="md"
                variant="minimal"
                animated={false}
                showTagline={false}
              />
            </div>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-4">
              Sidebar (Collapsed)
            </h3>
            <div className="flex justify-center">
              <CompanyLogo
                size="sm"
                variant="minimal"
                animated={false}
                showTagline={false}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Code Examples */}
      <div className="space-y-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Code Examples
        </h2>
        <div className="space-y-4">
          <div className="p-4 bg-gray-900 rounded-lg">
            <pre className="text-green-400 text-sm overflow-x-auto">
              {`// Authentication pages (Login, Reset Password)
<CompanyLogo 
  size="xl" 
  variant="full" 
  animated={true}
  showTagline={true}
/>

// Header navigation
<CompanyLogo 
  size="md" 
  variant="minimal" 
  animated={false}
  showTagline={false}
/>

// Sidebar (collapsed)
<CompanyLogo 
  size="sm" 
  variant="minimal" 
  animated={false}
  showTagline={false}
/>`}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
